import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ProducedItemService extends GenericService {
    constructor() {
        super('/produced_items', axiosInstance);
    }

    async pushCloud(producedItemId, payload = {}) {
        try {
            const response = await axiosInstance.post(
                `${this.baseUrl}/${this.encodePathSegment(producedItemId)}/cloud/push`,
                payload
            );
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }
}

export default new ProducedItemService(); 